export default __webpack_public_path__ + "static/media/WLTH_Taxis_Loop_v001.e20d650a.gif";